// The game bar's words: the date ("Oct 2"), the opponent with their rating at
// the time ("vs bob 1512"), and the game's place in the period counted oldest
// first, so the latest of 41 games is "41 of 41".

/** The local calendar date, "Oct 2". */
export const shortDate = (ms: number) => new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

/** "vs bob 1512": the opponent and their rating, each only when known; empty without either. */
export function opponentLabel(game: { opponent?: string; opponentRating?: number }): string {
  const parts = [game.opponent, game.opponentRating !== undefined ? String(game.opponentRating) : undefined].filter(Boolean);
  return parts.length ? `vs ${parts.join(' ')}` : '';
}

/** "38 of 41": the place of the game at `index` in a list newest first, counted oldest first. */
export function position(length: number, index: number): string {
  return `${length - index} of ${length}`;
}
